import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import { useStore } from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker.jsx';

class ComprobantesSearch extends Component {
  state = {
    index: '',
  };

  constructor(props) {
    super(props);

    const {
      filters: { from: asFrom, to: asTo },
    } = this.props.list;

    const from = !!asFrom ? moment(asFrom) : moment().subtract(7, 'days');
    const to = !!asTo ? moment(asTo) : moment();

    this.state = {
      from: from.toDate(),
      to: to.toDate(),
    };
  }

  handleOnKeywordChange = (keyword) => {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      search: keyword,
      field: this.state.index,
    });
  };

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  };

  handleOnDateChange = (date) => {
    const { filters } = this.props.list;
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.listActions.paginate({
      ...filters,
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });

    this.setState({
      from: date[0],
      to: date[1],
    });
  };

  handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    this.setState({
      index: id,
    });
  };

  getOmnisearchLegend = () => {
    const { index } = this.state;

    let legend = 'Omnisearch';

    switch (index) {
      case 'uuid':
        legend = 'Folio Fiscal';
        break;
      case 'codigo':
        legend = 'Codigo';
        break;
      case 'serie':
        legend = 'Serie';
        break;
      case 'serie_folio':
        legend = 'Serie/Folio';
        break;
      case 'emisor_id':
        legend = 'Id Emisor';
        break;
      case 'emisor_rfc':
        legend = 'RFC Emisor';
        break;
      case 'receptor_id':
        legend = 'Id Emisor';
        break;
      case 'receptor_rfc':
        legend = 'RFC Receptor';
        break;
      case 'receptor_nombre':
        legend = 'Nombre Receptor';
        break;

      default:
        break;
    }

    return legend;
  };

  render() {
    const { from, to } = this.state;
    const {
      filters: { search },
    } = this.props.list;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={[from, to]}
            onDateChange={this.handleOnDateChange}
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={this.handleOnKeywordChange}
            onClear={this.handleOnSearchClear}
            value={search}
          >
            <DropdownButton
              variant="outline-secondary"
              title={this.getOmnisearchLegend()}
              id="search-index"
              onSelect={this.handleOnSelectIndex}
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item id="uuid">Folio Fiscal</Dropdown.Item>
              <Dropdown.Item id="codigo">Código</Dropdown.Item>
              <Dropdown.Item id="serie">Serie</Dropdown.Item>
              <Dropdown.Item id="serie_folio">Serie/Folio</Dropdown.Item>
              <Dropdown.Item id="emisor_id">Id Emisor</Dropdown.Item>
              <Dropdown.Item id="receptor_rfc">Id Receptor</Dropdown.Item>
              <Dropdown.Item id="emisor_rfc">RFC Emisor</Dropdown.Item>
              <Dropdown.Item id="receptor_rfc">RFC Receptor</Dropdown.Item>
              <Dropdown.Item id="receptor_nombre">Nombre Receptor</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(ComprobantesSearch);
